(function () {
    'use strict';

    run.parts.select2 = function () {
        jQuery(document).ready(function($) {
            $('.select2_generic').select2();
        });
    };
})();